"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeMessageAdapter = void 0;
const sample_data_1 = require("@home-health-notify/sample-data");
const utils_1 = require("../../utils");
class FakeMessageAdapter {
    syncMessages(from, params, context) {
        throw new Error("Method not implemented.");
    }
    fetchRecipientInfo(messageId) {
        throw new Error("Method not implemented.");
    }
    getMessages(from, params, context) {
        const sampleData = Object.assign(Object.assign({}, sample_data_1.messagesData.data), { data: [] });
        return Promise.resolve((0, utils_1.CompletedResult)(sampleData));
    }
    setMessageStar(starMessageRequestData) {
        throw new Error("Method not implemented.");
    }
}
exports.FakeMessageAdapter = FakeMessageAdapter;
